<div *ngFor="let shopSession of shopSessions; let i = index; trackBy: trackByFn" class="shop-session-container"
     [ngClass]="{'shop-session-break': (i + 1) % 10 === 0 && i !== shopSessions.length - 1}">
    <div class="shop-session" [ngClass]="shopSession.isNew? 'new-shop-session': 'old-shop-session'">
        <div class="session-title-container">
            <div class="session-title">
                SESSION&nbsp;ID  {{ shopSession.shopSessionId }}
                <a href="javascript:void(0)" (click)="detailsClicked(shopSession.shopSessionId)" class="session-details">details</a>
                <div class="short-url">
                    {{shopSession.locale}}&nbsp;&nbsp;&nbsp;
                    <span *ngIf="shopSession.shortUrlId">{{ shopSession.shortUrlId }}</span>
                </div>
            </div>
            <div class="totals-container">
                <div class="totals-item">
                    <div class="totals-label">Total Events</div>
                    <div class="totals-value" [ngClass]="shopSession.totalEventsChanged? 'new-total-item': ''" >{{shopSession.shopSessionEvents?.length}}</div>
                </div>
                <div class="totals-item">
                    <div class="totals-label">Enrollments</div>
                    <div class="totals-value">{{shopSession.enrollments}}</div>
                </div>
                <div class="totals-item">
                    <div class="totals-label">Pending Orders</div>
                    <div class="totals-value">{{shopSession.pendingOrders}}</div>
                </div>
            </div>
            <table class="session-time-summary">
                <tr><td>Most Recent Event</td><td>{{ shopSession.recentEventDateTimeAgo}}</td></tr>
                <tr><td>Session Created</td><td>{{ shopSession.createDateTimeAgo}}</td></tr>
            </table>
        </div>

        <div class="session-details-section" *ngIf="showDetailsShopSessionId == shopSession.shopSessionId">
            <div class="table-container">
                <div class="shopSession-details">
                    <h4>Session Details</h4>
                    <table class="shopSession-details-table">
                        <tbody>
                        <tr>
                            <th>Long URL</th>
                            <td>{{ shopSession.longUrl }}</td>
                        </tr>
                        <tr>
                            <th>Referer</th>
                            <td>{{ shopSession.referer }}</td>
                        </tr>
                        <tr>
                            <th>User Agent:</th>
                            <td>{{ shopSession.userAgent }}</td>
                        </tr>
                        <tr>
                            <th>Locale:</th>
                            <td>{{ shopSession.locale }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="shopSession.shareable" class="shareable-section">
                    <h4>Shareable Details</h4>
                    <table class="shareable-table">
                        <tbody>
                        <tr>
                            <th>Sponsor</th>
                            <td>{{ shopSession.shareable.sponsorId }} - {{ shopSession.shareable.sponsorCustomerType }}</td>
                        </tr>
                        <tr>
                            <th>Share Type</th>
                            <td>{{ shopSession.shareable.shareType }} | {{ shopSession.shareable.shareId }}</td>
                        </tr>
                        <tr>
                            <th>Shopper Source</th>
                            <td>{{ shopSession.shareable.shopperSource }}</td>
                        </tr>
                        <tr>
                            <th>Share From Page</th>
                            <td>{{ shopSession.shareable.shareFrom }}</td>
                        </tr>
                        <tr>
                            <th>Placement</th>
                            <td>
                                <div *ngIf="shopSession.shareable.sharePlacementId">
                                    {{ shopSession.shareable.sharePlacementId }}.{{ shopSession.shareable.sharePlacementBc }}{{ shopSession.shareable.sharePlacementSide }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>ShortURL Created</th>
                            <td>{{ shopSession.shareable.createDateTimeAgo }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div *ngIf="shopSession.shopSessionEvents && shopSession.shopSessionEvents.length" class="events-section">
                <h4>Events</h4>
                <table class="event-table">
                    <thead>
                    <tr>
                        <th>Event Category</th>
                        <th>Event Type</th>
                        <th>Sponsor ID</th>
                        <th>Retail ID</th>
                        <th>Customer ID</th>
                        <th>Order ID</th>
                        <th>Event Data 1</th>
                        <th>Event Data 2</th>
                        <th>Event Happened</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let event of shopSession.shopSessionEvents; trackBy: trackByFn" [ngClass]="event.isNew? 'new-event-item': 'event-item'">
                        <td>{{ event.eventCategory }}</td>
                        <td>{{ event.eventType }}</td>
                        <td>{{ event.sponsorId }}</td>
                        <td>{{ event.retailId }}</td>
                        <td>{{ event.customerId}}</td>
                        <td>{{ event.orderId}}</td>
                        <td>{{ event.eventData1}}</td>
                        <td>{{ event.eventData2}}</td>
                        <td>{{ event.createDateTimeAgo}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
